import { useLazyQuery } from "@apollo/client";
import { SwitchRole } from "container/MyProfile/Components/SwitchRole";
import { RoleContext, RoleDispatchContext } from "context/RoleContext";
import { client } from "helper/apolloConfig";
import { globalVariables } from "helper/globalVariables";
import { edit } from "helper/icons";
import { Logout, logo, avatar, SwitchRole as SwitchRoleIcon } from "helper/images";
import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
  setAuthToken,
  setOriginalRoleAction,
  setRoleAction,
  setUser,
} from "redux/features/authSlice/AuthSlice";
import {
  setHostDetails,
  setTrialDetails,
} from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { setHostProfile } from "redux/features/hostSlice/profile/hostProfileSlice";
import { getMyMembeJudgeProfileQuery } from "redux/features/judgeSlice/judgeGql";
import { setJudgeDetails } from "redux/features/judgeSlice/judgeSlice";
import { updateMemberProfileMutation } from "redux/features/memberSlice/memberGql";
import { setMemberDetails } from "redux/features/memberSlice/memberSlice";
import { BottomButtons } from "shared/Components/bottomButtons";
import { Button } from "shared/Components/button";
import Dropdown from "shared/Components/dropdown";
import Loader from "shared/Components/loader";
import { PhoneInput } from "shared/Components/phoneInput";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { SearchLocation } from "shared/Components/searchLocation";
import { TabBar } from "shared/Components/tabBar";
import { TextInput } from "shared/Components/textInput";
import { TextArea } from "shared/Components/textarea";
import { ROLE } from "helper/utility";
import PageInfo from "shared/Components/pageInfo";
import { MobileHeader } from "shared/Components/mobileHeader";
import { SubmitButton } from "container/MyProfile/Components/SubmitButtons";

import { judgeProfileResolver } from "validators/UserValidation";

// Judge-specific constants
const JUDGE_DETAILS = "Judge Details";
const SWITCH_ROLE = "Switch Roles";
const judgeTabs = [JUDGE_DETAILS, SWITCH_ROLE];

// Judge Sidebar Component - Only has Switch-Roles
const JudgeSideNav = ({ first_name, last_name, profile, onLogout, onSwitchRoleClick }) => {
  const [profileImg, setProfileImg] = useState(profile);

  useEffect(() => {
    setProfileImg(profile);
  }, [profile]);

  return (
    <div className="fixed bg-100 h-full text-white" style={{ width: "280px" }}>
      <div className="cursor-pointer bg-white py-4 ml-4 border-lt rounded-lg mr-[-10px]">
        <Link to="/">
          <img src={logo} alt="Logo" className="h-15 w-32 ml-3" />
        </Link>
      </div>
      <div className="py-8 px-4 h-[72vh] overflow-y-scroll">
        <ul>
          <li
            className="mb-1 py-2 px-3 h-10 cursor-pointer hover:bg-lightBlue text-white rounded-md font-semibold bg-lightBlue"
            onClick={onSwitchRoleClick}
          >
            <div className="flex flex-row">
              <SwitchRoleIcon className="h-6 w-6 mr-3" />
              <span>Switch-Roles</span>
            </div>
          </li>
        </ul>
      </div>
      <div className="absolute self-center flex flex-row bottom-8 pt-6 mx-4 px-2">
        <div className="flex">
          <img
            src={profileImg ? profileImg : avatar}
            alt=""
            className="h-10 w-10 mr-3 border rounded-[50px]"
            onError={() => setProfileImg(avatar)}
          />
          <div className="flex flex-col mr-6">
            <p className="text-sm font-semibold text-white w-36 break-all">{`${first_name || ''} ${last_name || ''}`}</p>
            <p className="text-sm font-redular text-white w-36 break-all">Judge</p>
          </div>
        </div>
        <button type="button" onClick={onLogout}>
          <Logout />
        </button>
      </div>
    </div>
  );
};

export const JudgeProfile = () => {
  const [loading, setLoading] = useState(true);
  const [isEditable, setEditable] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(JUDGE_DETAILS);
  const [selectedRole, setSelectedRole] = useState("");
  const [checkValidation, setCheckValidation] = useState(false);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [timezone, setTimeZone] = useState("");
  const [distance, setDistance] = useState("");
  const dispatch = useDispatch();
  const role = useContext(RoleContext);
  const dispatchSetRole = useContext(RoleDispatchContext);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });

  const timeZoneOptions = [
    "ET - Eastern Time",
    "CT - Central Time",
    "MT - Mountain Time",
    "PT - Pacific Time",
    "HT - Hawaii Time",
    "AK - Alaska Time",
  ];

  const distanceOptions = [
    "Any Distance",
    "Up to 50 miles",
    "Up to 100 miles",
    "Up to 150 miles",
    "Up to 200 miles",
    "Up to 300 miles",
    "300+ miles",
  ];

  const memberDetails = useSelector(
    (state) => state?.auth?.memberReducer?.memberDetails
  );
  const { profile, first_name, last_name } = memberDetails || {};

  const [getData, { loading: getLoading, data: judgeData, error }] =
    useLazyQuery(getMyMembeJudgeProfileQuery, {
      fetchPolicy: "no-cache",
    });

  const modalRef = useRef();
  const judgeProfileRef = useRef();
  const [profileDataSave, setProfileDataSave] = useState({
    title: "",
    desc: "",
    type: "pending",
  });

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getJudgeProfile();
  }, [judgeData]);

  useEffect(() => {
    if (role) {
      setSelectedRole(role);
    }
  }, [role]);

  const handleChangeRole = (selected) => {
    dispatchSetRole(selected);
    setSelectedRole(selected);
    const roleSelected = selected;
    if (
      selected !== ROLE.Member &&
      !memberDetails?.role?.includes(roleSelected)
    ) {
      // modalRef.current.openModal();
      // setProfileDataSave({
      //   ...profileDataSave,
      //   title: globalVariables.error,
      //   desc: globalVariables.roleSwitchPermissionError,
      //   type: "pending",
      // });
    } else {
      if (selected === ROLE.Host) {
        dispatch(setHostProfile(memberDetails));
      }
      setSelectedRole(selected);
    }
  };

  const getJudgeProfile = async () => {
    console.log("Get Profile Called");
    try {
      // const res = await client.query(
      //   {
      //     query: getMyMembeJudgeProfileQuery,
      //   },
      //   { fetchPolicy: "no-cache" }
      // );
      // getData();

      setLoading(false);
      const data = judgeData?.getMyMemberProfile;
      if (data) {
        setValue("name", `${data?.first_name} ${data?.last_name}`);
        setValue("email", data?.email);
        setValue("phoneNumber", data?.phone_number);
        setValue("address", data?.location_address);
        setValue("zip", data?.zipCode);
        setCity(data?.city);
        setState(data?.state);
        setTimeZone(data?.timezone);
        setDistance(data?.distance_travel || "");

        dispatch(setJudgeDetails(data));
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
  } = useForm({
    resolver: judgeProfileResolver,
    defaultValues: {
      name: "",
      email: "",
      phoneNumber: "",
      address: "",
      zip: "",
    },
  });

  const onHandleSubmit = async (credentials) => {
    const names = credentials?.name?.trim()?.split(" ");
    const first_name = names[0];
    const last_name = names[names?.length - 1];

    if (!state || !city) {
      return;
    }

    const payload = {
      first_name: first_name,
      last_name: last_name ?? " ",
      location_address: credentials?.address,
      phone_number: credentials?.phoneNumber,
      distance_travel: distance,
      zipCode: credentials?.zip,
      state,
      city,
      timezone,
    };

    try {
      setUpdateLoading(true);
      const result = await client.mutate({
        mutation: updateMemberProfileMutation,
        variables: { data: payload },
      });

      setUpdateLoading(false);
      if (result?.data?.updateMyMemberProfile) {
        setEditable(false);
        onProfileSuccess();
      }
    } catch (error) {
      setUpdateLoading(false);
    }
  };

  const handleCancel = () => {
    if (selectedTab === SWITCH_ROLE) {
      setSelectedRole(role);
    } else {
      setEditable(false);
      getData();
      clearErrors();
    }
  };

  const onTabChange = (index) => {
    setSelectedTab(judgeTabs[index]);
    if (isEditable) {
      setEditable(false);
    }
  };

  const handelSaveChanges = () => {
    if (selectedTab === JUDGE_DETAILS) {
      onCheckValidation();
    }
  };

  const onCheckValidation = () => {
    handleSubmit(onHandleSubmit)();
    if (state && city) {
      setCheckValidation(false);
    } else {
      setCheckValidation(true);
    }
  };

  const onCloseModal = () => {
    if (profileDataSave.type === "success") {
      dispatchSetRole(selectedRole);
    }
  };

  const onLogout = () => {
    dispatch(setUser(null));
    dispatch(setAuthToken(""));
    dispatch(setMemberDetails(null));
    dispatch(setHostDetails(null));
    dispatch(setTrialDetails(null));
    dispatch(setRoleAction(""));
    dispatch(setOriginalRoleAction(""));
  };

  const onProfileSuccess = () => {
    modalRef.current.openModal();
    setEditable(false);
    setProfileDataSave({
      ...profileDataSave,
      title: globalVariables.success,
      desc: globalVariables.profileUpdatedSuccessDesc,
      type: "success",
    });
  };

  // Judge Details Form Component
  const JudgeDetailsForm = () => (
    <>
      <div className="w-full flex justify-center align-center">
        <span className="text-2xl md:text-3xl font-semibold text-gray-900 text-center mb-6">
          {globalVariables.judgeDetails || "Judge Details"}
        </span>
      </div>
      <form className="flex justify-center" onSubmit={handleSubmit(onHandleSubmit)}>
        <div className="max-[400px]:w-[90%]">
          <TextInput
            register={register}
            name="name"
            placeholder={globalVariables.enterName}
            errorMsg={errors.name?.message}
            disabled={!isEditable}
            label={globalVariables.name}
          />
          <div className="mt-5" />
          <TextInput
            register={register}
            name="email"
            placeholder={globalVariables.enterEmail}
            errorMsg={errors.email?.message}
            disabled
            label={globalVariables.emailId}
          />
          <div className="mt-5" />
          <TextArea
            register={register}
            name="address"
            placeholder={globalVariables.enterYourAddress}
            errorMsg={errors.address?.message}
            disabled={!isEditable}
            label={globalVariables.address}
          />
          <div className="mt-5" />
          <SearchLocation
            register={register}
            icon="right"
            name="state"
            width={"w-[358px] lg:w-[384px] max-[400px]:w-[100%]"}
            value={state}
            placeholder={globalVariables.state}
            label={globalVariables.state}
            types={["(regions)"]}
            onSelectLocation={(location) => setState(location)}
            errorMsg={!state && checkValidation ? globalVariables.selectFromOption : ""}
            disabled={!isEditable}
            defaultValue={state}
          />
          <div className="mt-5" />
          <SearchLocation
            register={register}
            icon="right"
            name="city"
            width={"w-[358px] lg:w-[384px] max-[400px]:w-[100%]"}
            value={city}
            placeholder={globalVariables.city}
            label={globalVariables.city}
            types={["(cities)"]}
            onSelectLocation={(location) => setCity(location)}
            errorMsg={!city && checkValidation ? globalVariables.selectFromOption : ""}
            disabled={!isEditable}
            defaultValue={city}
            searchBy={state}
          />
          <div className="mt-5" />
          <TextInput
            register={register}
            name="zip"
            placeholder={globalVariables.zip}
            label={globalVariables.zip}
            errorMsg={errors.zip?.message}
            type="number"
            disabled={!isEditable}
          />
          <div className="mt-5" />
          <PhoneInput
            name="phoneNumber"
            placeholder={globalVariables.enterPhoneNumber}
            errorMsg={errors.phoneNumber?.message}
            disabled={!isEditable}
            label={globalVariables.phoneNumber}
            value={watch("phoneNumber")}
            onChange={(e) => setValue("phoneNumber", e.target.value)}
          />
          <div className="mt-5" />
          <Dropdown
            width="w-[100%]"
            dropdownOptions={distanceOptions}
            defaultOption={distance}
            placeholder={globalVariables.typeYourDistance}
            label={globalVariables.distanceReadyTravel}
            onChange={setDistance}
            disabled={!isEditable}
          />
          <div className="mt-5" />
          <Dropdown
            width="w-[100%]"
            dropdownOptions={timeZoneOptions}
            defaultOption={timezone}
            placeholder={globalVariables.timeZone}
            label={globalVariables.timeZone}
            onChange={setTimeZone}
            disabled={!isEditable}
          />
        </div>
      </form>
    </>
  );

  const ActiveTab = () => {
    switch (selectedTab) {
      case JUDGE_DETAILS:
        return <JudgeDetailsForm />;
      case SWITCH_ROLE:
        return (
          <SwitchRole
            onChangeRole={handleChangeRole}
            defaultRole={selectedRole}
            isJudge
            rolesData={[...new Set(memberDetails?.role)]}
          />
        );
      default:
        return <></>;
    }
  };

  if (loading) {
    return <Loader />;
  }

  // Handle clicking Switch-Roles in sidebar
  const handleSwitchRoleClick = () => {
    setSelectedTab(SWITCH_ROLE);
    if (isEditable) {
      setEditable(false);
    }
  };

  return (
    <div className="p-3 bg-100 w-full">
      {/* Sidebar or Mobile Header */}
      {!isMobile && !isTablet ? (
        <JudgeSideNav
          first_name={first_name}
          last_name={last_name}
          profile={profile}
          onLogout={onLogout}
          onSwitchRoleClick={handleSwitchRoleClick}
        />
      ) : (
        <MobileHeader />
      )}

      {/* Main Content - Same layout as MyProfile */}
      <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
        <PageInfo title="Judge Details" />
        <div className="mt-0 md:mt-8 lg:mt-8 px-4" />
        {/* Sticky TabBar with Edit/Save/Cancel buttons */}
        <div className="sticky top-0 z-50 bg-white px-4 py-4 flex justify-center md:justify-between lg:justify-between">
          <TabBar tabs={judgeTabs} onChangeTab={onTabChange} />
          {selectedTab !== SWITCH_ROLE && (
            <SubmitButton
              handleCancel={handleCancel}
              handelSave={handelSaveChanges}
              selectedTab={selectedTab}
              setEditable={setEditable}
              isEditable={isEditable}
            />
          )}
        </div>
        <div className="mt-8" />
        <ActiveTab />

        {/* Mobile bottom buttons */}
        <div className="md:hidden lg:hidden">
          {isEditable && selectedTab !== SWITCH_ROLE ? (
            <BottomButtons
              outlineLabel={"Cancel Changes"}
              fullLabel={"Save Changes"}
              onTapYes={handelSaveChanges}
              onTapNo={handleCancel}
              position={isMobile ? "fixed" : "sticky"}
              extraClass={isMobile ? "h-[80px]" : "dog-signup-bb-h"}
              btnCustomWidth="w-40 lg:w-44 max-[400px]:w-[140px] max-[280px]:w-[130px]"
            />
          ) : !isEditable && selectedTab !== SWITCH_ROLE ? (
            <div className="fixed w-full bottom-0 h-20 flex items-center justify-center border border-solid border-gray-300 bg-white">
              <Button
                onClick={() => setEditable(!isEditable)}
                width={"w-32"}
                label={globalVariables.edit}
                icon={edit}
                prefix={false}
              />
            </div>
          ) : null}
        </div>
      </div>

      <PopUpMessages
        title={profileDataSave.title}
        desc={profileDataSave.desc}
        type={profileDataSave.type}
        ref={modalRef}
        onCloseModal={onCloseModal}
      />
    </div>
  );
};
